<template>
    <b-modal
        title-tag="h2"
        title="Lock Letter"
        :lazy="true"
        :visible="isOpen"
        @ok="proceed"
    >
        Locked letter cannot be edited. Are you sure you want to lock this
        letter?

        <template v-slot:modal-footer>
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button v-if="!isLoading" variant="primary" @click="proceed">
                Lock
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import PatientDocument from "@/services/patient-documents";
import Loader from "@/module/commons/loader";

export default {
    name: "LockLetter",
    components: {
        Loader
    },
    data() {
        return {
            id: null,
            isOpen: false,
            isLoading: false
        };
    },
    computed: {},
    methods: {
        open(id) {
            this.isOpen = true;
            this.id = id;
        },
        close() {
            this.isOpen = false;
        },
        async proceed() {
            try {
                this.isLoading = true;

                let res = await PatientDocument.lockLetter(this.id);

                if (res.message.code == 200) {
                    this._message(" Letter locked");
                    this.$emit("after-lock", {
                        isLock: true
                    });
                } else {
                    this._message("Error: Unable to lock", "danger");
                }

                this.close();
            } catch (error) {
                this.isLoading = false;
                this._message("Error: Unable to lock", "danger");
            }
        }
    }
};
</script>
